import { cn } from "lib/utils";
import { lpConfig } from "routes/LandingPage/lpConfig";
import { useFadeIn } from "routes/LandingPage/useFadeIn";

/**
 * 導入企業の実績を示すインパクトセクション
 * KPIカウンターと導入前後の比較テーブルを表示する
 * @return {JSX.Element} インパクトセクションコンポーネント
 */
export function LpImpact() {
  const { ref, isVisible } = useFadeIn();

  return (
    <section id="impact" className="py-24 lg:py-32 bg-[#02072F]">
      <div
        ref={ref}
        className={cn(
          "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lp-fade-in-up",
          isVisible && "lp-visible",
        )}
      >
        <div className="text-center">
          <p className="text-xs font-bold tracking-widest text-[#2B92FF] uppercase mb-4">
            {lpConfig.impact.sectionLabel}
          </p>
          <h2 className="text-4xl font-bold text-white mb-16">
            {lpConfig.impact.heading}
          </h2>
        </div>

        {/* KPI Cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {lpConfig.impact.kpiCards.map(kpi => (
            <div
              key={kpi.label}
              className="text-center p-6 rounded-2xl bg-white/5 border border-white/10 backdrop-blur-sm"
            >
              <p className="text-5xl lg:text-6xl font-bold text-[#ff8d00] mb-2">
                {kpi.value}
              </p>
              <p className="text-white font-medium mb-1">{kpi.label}</p>
              <p className="text-sm text-gray-400">{kpi.sublabel}</p>
            </div>
          ))}
        </div>

        {/* Comparison Table */}
        <div className="mt-16 overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="text-gray-400 text-sm">
                <th className="py-3 px-4"></th>
                <th className="py-3 px-4">
                  {lpConfig.impact.comparisonTable.headers.before}
                </th>
                <th className="py-3 px-4">
                  {lpConfig.impact.comparisonTable.headers.after}
                </th>
                <th className="py-3 px-4">
                  {lpConfig.impact.comparisonTable.headers.effect}
                </th>
              </tr>
            </thead>
            <tbody>
              {lpConfig.impact.comparisonTable.rows.map(row => (
                <tr key={row.feature} className="border-t border-white/10">
                  <td className="py-4 px-4 text-white font-medium whitespace-nowrap">
                    {row.feature}
                  </td>
                  <td className="py-4 px-4 text-gray-400">{row.before}</td>
                  <td className="py-4 px-4 text-[#30BF78] font-bold whitespace-nowrap">
                    {row.after}
                  </td>
                  <td className="py-4 px-4 text-gray-300 text-sm">
                    {row.effect}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
